/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.css';
import FormBuilder from "@/components/formBuilder";
import forms from "@/configs/forms";
import { countries } from "./helpers";
import { formIsLoading, handleSubmitDistributorForm } from "./helpers.client";
import TextInput from "@/components/formBuilder/components/textInput";
import SelectInput from "@/components/formBuilder/components/selectInput";
import ButtonInput from "@/components/formBuilder/components/buttonInput";
import { cn } from "@/utils/theme/cn";
export default function SupportForm(param) {
    let {} = param;
    return /*#__PURE__*/ _jsxs(FormBuilder, {
        className: styles.holder,
        id: forms.distributor,
        onSubmit: handleSubmitDistributorForm,
        loadingOnSubmit: false,
        children: [
            /*#__PURE__*/ _jsx(TextInput, {
                required: 'enter_company_name',
                path: 'company_name',
                label: 'company_name',
                className: styles.input
            }),
            /*#__PURE__*/ _jsx(TextInput, {
                required: 'enter_fiend_of_activity',
                path: 'field_of_activity',
                label: 'field_of_activity',
                className: styles.input
            }),
            /*#__PURE__*/ _jsx(SelectInput, {
                fixed: true,
                required: 'enter_country',
                searchable: true,
                path: 'country',
                label: 'country',
                clearable: false,
                options: countries,
                inputClassName: styles.input,
                menuClassName: styles.input,
                moreOnChange: (_, formMethods)=>formMethods.setValue('city', null)
            }),
            /*#__PURE__*/ _jsx(SelectInput, {
                fixed: true,
                required: 'enter_city',
                searchable: true,
                path: 'city',
                label: 'city',
                clearable: false,
                inputClassName: styles.input,
                menuClassName: styles.input,
                watchingPaths: [
                    'country'
                ],
                options: (country)=>(country === null || country === void 0 ? void 0 : country.cities) || []
            }),
            /*#__PURE__*/ _jsx(TextInput, {
                required: 'enter_contact_person_name',
                path: 'contact_person_name',
                label: 'contact_person_name',
                className: styles.input
            }),
            /*#__PURE__*/ _jsx(TextInput, {
                required: 'enter_position',
                path: 'position',
                label: 'position',
                className: styles.input
            }),
            /*#__PURE__*/ _jsx(TextInput, {
                email: true,
                required: 'enter_email',
                path: 'email',
                label: 'email_address',
                className: styles.input
            }),
            /*#__PURE__*/ _jsx(TextInput, {
                required: 'enter_phone_number',
                path: 'phone_number',
                label: 'phone_number',
                className: styles.input
            }),
            /*#__PURE__*/ _jsx(TextInput, {
                required: 'enter_message',
                path: 'message',
                label: 'message',
                rows: 4,
                className: cn('col-span-full', styles.input)
            }),
            /*#__PURE__*/ _jsx(ButtonInput, {
                rounded: true,
                variant: 'filled',
                color: 'primary',
                form: forms.distributor,
                label: 'submit',
                watchingPaths: [
                    'formIsLoading'
                ],
                loading: formIsLoading,
                className: 'md:col-start-2 w-fit! justify-self-end'
            })
        ]
    });
}
